import { createSelector } from 'reselect';

import type { State } from 'reducers';

import { initialState } from './reducer';

const selectState = (state: State) => state.get('deedFormPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));

export const selectPartnersLoading = createSelector(selectState, (state) =>
  state.get('partnersLoading')
);

export const selectActiveStep = createSelector(selectState, (state) => state.get('activeStep'));

export const selectUploadedFile = createSelector(selectState, (state) => state.get('uploadedFile'));
